
import { CreateWorkplaceRequest } from "types";
import { apiService } from "../services/apiService";
import { paginationService } from "../services/paginationService";
import { getCurrentWorkplaceId } from 'core/session/workplaceStore';


// Separate API Service for Workplace with configurable base URL


// Create instance of the workplace API service
const workplaceApiService = apiService

/***********************************  Add WorkPlace Api ******************************/

export const createWorkplace = async (
  data: CreateWorkplaceRequest
): Promise<any> => {
  const response = await workplaceApiService.post<CreateWorkplaceRequest>(
    "/workplaces",
    data
  );
  // console.log("createWorkplace response", response);
  return response.data;
};

// API function to update a workplace
export const updateWorkplace = async (
  data: CreateWorkplaceRequest
): Promise<CreateWorkplaceRequest> => {
  const workplaceId = getCurrentWorkplaceId();
  const response = await workplaceApiService.post<CreateWorkplaceRequest>(
    `/workplaces/${workplaceId}`,
    data
  );
  return response.data;
};

// API function to update a workplace by ID
export const updateWorkplaceById = async (
  workplaceId: number,
  data: CreateWorkplaceRequest
): Promise<CreateWorkplaceRequest> => {
  const response = await workplaceApiService.put<CreateWorkplaceRequest>(
    `/workplaces/${workplaceId}`,
    data
  );
  return response.data;
};




// API function to fetch workplaces
export const fetchWorkplaces = async (
  params: {
    limit?: number;
    page?: number;
    create_predictions: 0 | 1;
  }
): Promise<any> => {
  const queryParams = new URLSearchParams();
  queryParams.append('create_predictions', params.create_predictions.toString());
  
  const itemsPerPage = Math.min(params.limit || 30, 30);
  const data = await paginationService.getWithHandler(`/workplaces?${queryParams.toString()}`, undefined, itemsPerPage);
  
  const workplaces = data?.member?.map(({ '@type': type, id, ...rest }) => ({
    id,
    type,
    ...rest
  })) || [];
  return workplaces;
};


// Retrive single workplace API function
export const getSingleWorkplace = async (workplaceId:number): Promise<void> => {
  // const workplaceId = getCurrentWorkplaceId();
  const res = await workplaceApiService.get(`/workplaces/${workplaceId}`);
  return res.data;
}


// Delete workplace API function
export const deleteWorkplace = async (workplaceId: number): Promise<void> => {
  const res = await workplaceApiService.delete(`/workplaces/${workplaceId}`);
  return res.data;
}




// API function to fetch operating units
export const fetchOperatingUnits = async (
  params: {
    orderBy: string;
    direction: 'ASC' | 'DESC';
    limit: number;
    page: number;
  }
): Promise<any> => {
  const response = await workplaceApiService.get<any>('/operating-units', {
    params,
  });
  return response.data;
};



// API function to fetch workplaces type
export const fetchWorkplaceType = async (
  params: {
    orderBy: string;
    direction: 'ASC' | 'DESC';
    limit: number;
    page: number;
  }
): Promise<any> => {
  const response = await workplaceApiService.get<any>('/workplace-types', {
    params,
  });
  return response.data;
};

// Export all functions as a service object for easier importing
export const workplaceService = {
	createWorkplace,
	updateWorkplace,
	updateWorkplaceById,
	fetchWorkplaces,
	getSingleWorkplace,
	deleteWorkplace,
	fetchOperatingUnits,
	fetchWorkplaceType
};

export default workplaceService;